import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPassword } from '@/features/auth/reset-password'

const ZodResetPasswordSearch = z.object({
  // Better Auth appends the reset token; `error` is set when it rejected the link.
  token: z.string().optional(),
  error: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/reset-password')({
  component: ResetPassword,
  validateSearch: ZodResetPasswordSearch,
})
